import React, {useState} from "react";
import {Button, Input, message, Popconfirm, Popover} from "antd";
import {useStore} from "../../../../../../hooks/useStore";
import {CheckOutlined, InfoCircleOutlined, StopOutlined} from "@ant-design/icons";
import JSONInput from "react-json-editor-ajrm";

export const BlockWithdrawButton = ({wallet, walletLoading, reloadWallet}) => {
    const stores = useStore();
    const [blockReason, setBlockReason] = useState("");
    const [blockWithdrawLoading, setBlockWithdrawLoading] = useState(false);

    const handleBlockWithdraw = async () => {
        if (!blockReason) {
            message.error("Lütfen bir sebeb belirtin.");
            return;
        }
        try {
            setBlockWithdrawLoading(true);

            await stores.walletStore.blockWithdrawAction({
                walletId: wallet?._id,
                reason: blockReason
            });

            reloadWallet();
            setBlockReason("");
            message.success("Para çekme bloklaması başarıyla gerçekleştirildi.");
        } catch (error) {
            console.error(error);
        } finally {
            setBlockWithdrawLoading(false);
        }
    };

    const handleUnblockWithdraw = async () => {
        try {
            setBlockWithdrawLoading(true);

            await stores.walletStore.unblockWithdrawAction({
                walletId: wallet?._id
            });

            reloadWallet();
            message.success("Para çekme bloklaması başarıyla kaldırıldı.");
        } catch (error) {
            console.error(error);
        } finally {
            setBlockWithdrawLoading(false);
        }
    };

    const checkPermission = permission => {
        const permissions = {
            blockWithdraw: !wallet?.withdrawActionBlockedInfo?.isWithdrawActionBlocked,
            unblockWithdraw: wallet?.withdrawActionBlockedInfo?.isWithdrawActionBlocked
        };

        return permissions?.[permission] || false;
    };

    const renderBlockWithdrawButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h3>
                        <b>Para Çekmeyi Blokla</b>
                    </h3>
                    <p>Bu cüzdandan para çekmeyi bloklamak istediğinize emin misiniz? </p>
                    <p>
                        Bu işlem yapıldıktan sonra; <br />
                        <b>kurye, cüzdandan para çekemeyecektir.</b>
                    </p>
                    <p>Lütfen para çekmeyi bloklamanın sebebini belirtin.</p>
                    <Input.TextArea
                        placeholder="Para çekmeyi bloklamanın sebebini giriniz."
                        style={{marginTop: "10px"}}
                        value={blockReason}
                        onChange={e => {
                            setBlockReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => handleBlockWithdraw()}
            okText={"Blokla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !blockReason}}
            disabled={!checkPermission("blockWithdraw")}
        >
            <Button
                loading={walletLoading || blockWithdrawLoading}
                danger
                icon={<StopOutlined />}
                style={{
                    opacity: !checkPermission("blockWithdraw") ? 0.5 : 1
                }}
                disabled={!checkPermission("blockWithdraw")}
            >
                {wallet?.withdrawActionBlockedInfo?.isWithdrawActionBlocked
                    ? "Para Çekme Bloklu"
                    : "Para Çekmeyi Blokla"}
            </Button>
        </Popconfirm>
    );

    const renderUnblockWithdrawButton = () => (
        <>
            <Popover
                content={
                    <JSONInput
                        id="courierLogGPSProviderJSON"
                        placeholder={wallet?.withdrawActionBlockedInfo}
                        theme="dark_mitsuketa_tribute"
                        width="300px"
                        height="auto"
                        viewOnly={true}
                        confirmGood={false}
                    />
                }
            >
                <InfoCircleOutlined style={{marginRight: "8px"}} />
            </Popover>
            <Popconfirm
                placement="bottomLeft"
                icon={null}
                title={
                    <>
                        <h3>
                            <b>Para Çekme Bloklamayı Kaldır</b>
                        </h3>
                        <p>
                            Bu cüzdandan para çekmeyi bloklamayı kaldırmak istediğinize emin
                            misiniz?{" "}
                        </p>
                        <p>
                            Bu işlem yapıldıktan sonra; <br />
                            <b>kurye, cüzdandan para çekebilecektir.</b>
                        </p>
                    </>
                }
                overlayStyle={{
                    width: "300px"
                }}
                onConfirm={() => handleUnblockWithdraw()}
                okText={"Kaldır"}
                cancelText={"İptal"}
                disabled={!checkPermission("unblockWithdraw")}
            >
                <Button
                    loading={walletLoading || blockWithdrawLoading}
                    type="primary"
                    icon={<CheckOutlined />}
                    style={{
                        opacity: !checkPermission("unblockWithdraw") ? 0.5 : 1
                    }}
                    disabled={!checkPermission("unblockWithdraw")}
                >
                    {wallet?.withdrawActionBlockedInfo?.isWithdrawActionBlocked
                        ? "Para Çekme Bloklamasını Kaldır"
                        : "Para Çekme Bloklaması Kaldırılmış"}
                </Button>
            </Popconfirm>
        </>
    );

    return (
        <>
            {checkPermission("blockWithdraw") && renderBlockWithdrawButton()}

            {checkPermission("unblockWithdraw") && renderUnblockWithdrawButton()}
        </>
    );
};
